export default {
  sp: {
    common: {
      Email: 'Email',
      Account: 'Tài Khoản',
      Password: 'Mật Khẩu',
      Register: 'Đăng ký',
      Required: 'Bắt buộc',
      Name: 'Tên',
      Mobile: 'Di động',
      Title: 'Tiêu đề',
      Message: 'Tin nhắn',
      Verification_Code: 'Mã xác minh',
      email_tips: 'Vui lòng nhập email hợp lệ',
      mobile_tips: 'Vui lòng nhập số điện thoại hợp lệ',
      continue: 'Tiếp tục',
      send: 'Gửi',
      resend: 'Gửi lại',
      edit: 'Chỉnh sửa',
      delete: 'Xoá',
      ok: 'Đồng ý',
      confirm: 'Xác nhận',
      save: 'Lưu',
      cancel: 'Huỷ',
      change: 'Thay đổi',
      close: 'Đóng',
      select: 'Chọn',
      apply: 'Áp dụng',
      are_you_sure_to_delete_it: 'Bạn có chắc chắn muốn xoá không?',
      full_name: 'Họ và Tên',
      u_full_name: 'Họ và tên ',
      mobile_phone: 'Số di dộng',
      u_email_address: 'Địa chỉ email',
      promo_code: 'Mã khuyến mãi',
      no_data: 'Không có dữ liệu',
      view_more: 'Xem thêm',
      learn_more: 'Tìm hiểu thêm',
      promotion_has_ended: 'Rất tiếc, ưu đãi này đã kết thúc!',
      end: 'Kết thúc',
      SKU: 'Mã sản phẩm:',
      quantity: 'Số lượng:',
      delivery: 'Giao hàng:',
      success: 'Thanh công',
      you_may_also_like: 'Có thể bạn cũng thích',
      sale: 'SALE',
      password_valid_tips:
        'Giá trị phải chứa các ký tự đặc biệt gồm cả chữ và số Và ít nhất sáu',
      billing_address: 'Địa chỉ thanh toán',
      company_address: 'Công ty Địa chỉ',
      days: 'Ngày',
      hours: 'Giờ',
      minutes: 'Phút',
      seconds: 'Giây',
      start_in: 'Bắt đầu vào',
      end_in: 'Kết thúc vào',
      it_is_over: 'Đã kết thúc',
      find_products_in_store: 'Tìm sản phẩm tại cửa hàng Digibox',
      details: 'Mô tả ',
      specification: 'Thông số kỷ thuật',
      perfect_companion: 'Gợi Ý Phụ Kiện Đi Kèm',
      are_you_sure_delete_it: 'Bạn có chắc muốn xoá?',
      are_you_sure_delete_product: 'Are you sure to delete the products?',
      are_you_sure_to_delete_invalid_products:
        'Bạn có chắc chắn xoá tất cả sản phẩm không hợp lệ?',
      select_a_store: 'Vui lòng chọn một cửa hàng',
      select_one_item_least: 'Vui lòng chọn ít nhất một sản phẩm!',
      my_account: 'Tài khoản của tôi',
      my_orders: 'Đơn hàng của tôi',
      my_address: 'Địa chỉ của tôi',
      xx_installment_tax: '{name} Trả góp {n}%',
      n_months: '{n} Tháng',
      price_month: '{giá}/tháng',
      must_member_login_tips: 'Bạn có chắc chắn muốn huỷ đơn hàng?',
      are_you_sure_to_receive_the_order: 'Bạn có chắc chắn muốn huỷ đơn hàng?',
      are_you_sure_to_cancel_the_order: 'Bạn có chắc chắn muốn huỷ đơn hàng?',
      filter_by: 'Lọc theo',
      password_updated_successfully_tips:
        'Mật khẩu được cập nhật thành công, vui lòng đăng nhập.',
      validation_code_sent_successfully: 'Mã xác thực đã được gửi thành công!',
      your_registration_is_successful: 'Việc đăng ký của bạn đã thành công!',
      verification_code_sent_email_tips:
        'Mã xác minh đã được gửi, vui lòng kiểm tra trong hộp thư.',
      verification_code_is_incorrect_tips:
        'Mã xác minh không chính xác, vui lòng kiểm tra lại.',
      i_accept_x: '*Tôi chấp nhận',
      privacy_policy: 'Chính sách bảo mật',
      term_conditions: 'Điều khoản & Điều kiện',
      sign_in: 'Đăng nhập',
      return: 'Trả lại',
      return_details: 'Chi tiết trả lại',
      reason: 'Lý do',
      are_you_sure_to_return_the_order:
        'Bạn có chắc chắn để trả lại đơn đặt hàng?',
      logistics_info: 'Thông tin Logistics',
      logistics_company: 'Công ty Logistics',
      tracking_no: 'Theo dõi số',
      not_receive_tips:
        'Có những mặt hàng chưa được vận chuyển và không thể ký đơn hàng',
      undo_return: 'Hoàn tác trả lại',
      yes: 'Vâng',
      no: 'Không'
    },
    login: {
      or: 'Hoặc',
      login: 'Đăng nhập',
      error_tips: 'Sai tên đăng nhập hoặc mật khẩu',
      Forgot_passwords: 'Quên mật khẩu?',
      register_now: 'Đăng ký',
      Send_email: 'Gửi mã xác minh qua email',
      Log_in: 'Đăng nhập',
      create_account: 'Tạo tài khoản',
      forgot_password: 'Quên mật khẩu',
      account_Email: 'Tài khoản/ Email',
      send_email: 'Gửi mã xác minh qua email',
      Recovery_Code: 'Mã xác minh',
      New_Password: 'Mật khẩu mới',
      Change_Password: 'Đổi mật khẩu',
      Sign_in_with_Google: 'Đăng nhập với Google',
      Sign_in_with_Facebook: 'Đăng nhập với Facebook',
      guest_checkout: 'Thanh toán ngay, không cần tài khoản thành viên',
      guest_checkout_desc1:
        'Tiết kiệm thời gian và đi giao hàng để thanh toán.',
      guest_checkout_desc2:
        'Bạn có thể đăng ký tài khoản sau khi hoàn tất thanh toán',
      already_member_verify: 'Bạn đã có tài khoản, đăng nhập ngay!',
      returning_user: 'Khách hàng cũ?',
      sign_in_to_use_saved_information:
        'Đăng nhập để sử dụng thông tin đã được lưu trữ',
      enter_correct_name_or_password:
        'Tên đăng nhập hoặc mật khẩu chưa chính xác',
      have_account: 'Đã có tài khoản',
      back_to_login: 'Quay lại đăng nhập',
      Not_same_as_the_password_first_time:
        'Không giống với mật khẩu bạn đã nhập lần đầu tiên',
      reset_email_link_tips:
        'Nhập email của bạn và chúng tôi sẽ gửi cho bạn liên kết đặt lại mật khẩu.'
    },
    store: {
      contact: 'Liên hệ',
      hint: 'Bản đồ'
    },
    contact: {
      send_message: 'Gửi tin nhắn',
      contact_us: 'Liên hệ',
      submit_succeeded: 'Gửi thành công',
      contact_us_tips:
        'Chúng tôi đã nhận được yêu cầu và sẽ phản hồi trong thời gian nhanh nhất. Cám ơn Quý khách.'
    },
    account: {
      hello: 'Xin chào, {name}',
      welcome: 'Chào mừng {site}.',
      LOGOUT: 'Đăng xuất',
      user: 'Người dùng'
    },
    order: {
      home_delivery: 'Giao hàng tận nơi',
      store_pickup: 'Nhận tại cửa hàng',
      my_order: 'Đơn hàng của tôi',
      n_orders: '({n} Đơn hàng)',
      pay_now: 'Thanh toán ngay',
      order_details: 'Thông tin đơn hàng',
      end: 'Kết thúc',
      no_orders: 'Không có đơn hàng',
      cancel: 'Huỷ',
      n_products: '({n} Sản phẩm)',
      order_list: 'Danh sách đơn hàng',
      product_list: 'Danh sách sản phẩm',
      pickup_code: 'Mã nhận hàng:',
      receive_order: 'Nhận đơn hàng',
      orders_made: 'Đơn hàng đã đặt',
      online_invoice: 'Hoá đơn điện tử',
      order_status: 'Tình trạng đặt hàng',
      offline_invoice: 'Hoá đơn',
      time: 'Thời gian',
      shipping_method: 'Phương thức vận chuyển',
      shipping_code: 'Mã vận chuyển',
      shipping_fee: 'Phí vận chuyển',
      shipping_address: 'Địa chỉ giao hàng',
      full_name: 'Tên đầy đủ',
      phone: 'Điện thoại',
      address: 'Địa chỉ',
      payment_info: 'Thông tin thanh toán',
      payment_method: 'Phương thức thanh toán',
      payment_status: 'Trạng thái Thanh toán',
      payment_time: 'Thời gian trả tiền',
      value: 'Giá trị',
      sku: 'Mã sản phẩm',
      price: 'Giá tiền',
      qty: 'Số lượng',
      total_n_products: 'Tổng ({n} Sản phẩm)',
      discount: 'Giảm giá',
      voucher: 'Voucher',
      total: 'Tổng cộng',
      subtotal: 'Tổng phụ',
      coupon_discount: 'Voucher giảm giá',
      subtotal_n_products: 'Tạm tính ({n} Sản phẩm)',
      track_your_order: 'Theo dõi đơn hàng',
      track_your_order_desc: 'Vui lòng nhập email bạn đã dùng để đặt hàng',
      invoice: 'giấy đặt hàng',
      Return_Refund_detail: 'Return Refund detail',
      undo_return: 'Undo Return',
      fill_logistics_info: 'Fill Logistics Info',
      refund: 'Refund',
      delivery_method: 'Delivery Method'
    },
    payment: {
      payment: 'Thanh toán',
      your_order_no_is_xx: 'Mã đơn hàng.{orderCode}',
      thank_you_for_your_purchase: 'Cám ơn Quý khách!',
      pay_result_success_tips:
        'Chúng tôi sẽ gửi email xác nhận đặt hàng và mã vận đơn để Quý khách theo dõi.',
      continue_shopping: 'Tiếp tục mua sắm',
      something_went_wrong: 'Có lỗi xảy ra',
      the_transaction_is_unsuccessful: '\nThanh toán không thành công',
      please_contact_customer_service: 'Vui lòng liên hệ nhân viên hỗ trợ',
      view_details: 'View Details',
      order_is_processing: 'Yêu cầu đang được xử lý'
    },
    address: {
      address: 'Địa chỉ',
      add_new_address: 'Thêm địa chỉ mới',
      Please_save_the_billing_address_at_first:
        'Vui lòng lưu Địa chỉ thanh toán trước.',
      please_save_the_shipping_address_at_first:
        'Vui lòng lưu lại Địa chỉ nhận hàng.',
      corporate: 'Công ty',
      personal: 'Cá nhân',
      company_name: 'Thông tin công ty',
      your_company_name: 'Công ty',
      tax_code: 'Mã số thuế',
      u_tax_code: 'Mã số thuế ',
      first_name: 'Tên đầu tiên',
      your_first_name: 'Tên đầu tiên của bạn',
      last_name: 'Họ',
      your_last_name: 'Họ của bạn',
      contact_number: 'Điện thoại liên hệ',
      please_input_the_correct_phone_number:
        'Số điện thoại không hợp lệ (độ dài từ 10 - 11 ký tự, không chứa ký tự đặc biệt và khoảng trắng)',
      email: 'E-mail',
      email_address: 'Địa chỉ email của bạn',
      please_input_the_correct_email_address: 'Vui lòng nhập email hợp lệ',
      state_Province: 'Bang/Tỉnh',
      county_city: 'Quận/TP',
      town_districts: 'Thị trấn/Huyện',
      postal_code: 'Mã bưu chính',
      zip_postal_Code: 'Mã Zip/Mã Bưu điện',
      city: 'Thành phố',
      select_county_city: 'Chọn hạt/thành phố',
      province: 'Tỉnh thành',
      districts: 'Các quận',
      select_province: 'Chọn tỉnh',
      your_mobile_phone: 'Điện thoại di động của bạn',
      country: 'Quốc gia',
      zip_code_valid:'Mã bưu chính phải có năm ký tự'
    },
    checkout: {
      please_check_the_form: 'Vui lòng kiểm tra lại thông tin đã nhập',
      checkout: 'Thanh toán',
      ship_to: '1. Giao hàng đến',
      pay_with: '2. Thanh toán với',
      back_to_cart: 'Quay lại giỏ hàng',
      coupon: 'Mã khuyến mãi',
      choose_coupon: 'Chọn Mã khuyến mãi',
      billing_address_same_as_shipping:
        'Địa chỉ thanh toán và địa chỉ giao hàng giống nhau',
      find_the_nearest_store: 'Tìm cửa hàng store gần nhất',
      store_location: 'Vị trí cửa hàng Store',
      pick_up_at: '1. Nhặt tại',
      store_info: 'Thông tin cửa hàng'
    },
    pdp: {
      sold_out: 'Bán hết',
      installment_simulation: '{n}% Tiến hành Trả góp',
      add_to_cart: 'Thêm vào giỏ hàng',
      stock_status: 'Tình trạng sản phẩm:',
      stock_available: 'Có sẵn',
      remind_when_available: 'Nhắc khi có',
      please_select_a_attrname: 'Vui lòng chọn một {attrName}',
      no_available_coupons: 'Không có phiếu thưởng nào'
    },
    plp: {
      filter: 'Lọc',
      clear_all: 'Xoá tất cả',
      current_page_total_item: '{currentPage}/{total} sản phẩm',
      search_results_for_product: 'Kết quả tìm kiếm ({n})',
      all_product_n: 'Tất cả Sản Phẩm ({n})',
      no_results_were_found: 'Rất tiếc, không tìm thấy kết quả!',
      BRAND: 'Brand',
      CATEGORY: 'Collection',
      SIZE: 'Size',
      COLOR: 'Color',
      STOCK: 'Stock',
      PRICE: 'Price'
    },
    shop_cart: {
      all_products: 'Tất cả sản phẩm',
      invalid_products: 'Sản phẩm không hợp lệ',
      home_delivery: 'Giao hàng tận nơi',
      home_delivery_desc: 'Đơn hàng sẽ được giao đến địa chỉ bạn đã lựa chọn',
      pick_up_at_store: 'Nhận tại cửa hàng',
      pick_up_at_store_desc: 'Nhận sản phẩm đã chọn tại cửa hàng',
      Your_cart_amount_is_total_price: 'Tổng cộng {totalPrice}',
      shopping_cart: 'Giỏ hàng',
      order_summary: 'Tóm tắt đơn hàng',
      n_items: '({n} sản phẩm)',
      cart_empty: 'Giỏ hàng của bạn trống.',
      select_city: 'Select the city',
      no_available_stores: 'No available stores for the selected items'
    },
    subscribe: {
      subscribe_tips: 'Thank you for signing up for the digibox newsletter.',
      email_placeholder: 'Enter email address'
    },
    coupon: {
      my_coupon: 'My Coupons',
      unused_n: 'Unused ({n})',
      used_n: 'Used ({n})',
      expired_n: 'Expired ({n})',
      expired: 'Expired',
      no_available_coupons: 'No available coupons.',
      no_details: 'No details.'
    },
    account_setting: {
      account_setting: 'Account Setting',
      edit_xx: 'Edit {title}'
    },
    wishlist: {
      my_wishlist: 'My Wishlist',
      no_any_items: "You haven't saved any items yet."
    },
    points: {
      use_x_points: 'Use {x} Points',
      use_x_points_m: 'Use {x} Points?',
      available_points_n: 'Available Points:{n}',
      redeem: 'Redeem',
      sign_in_sign_up: 'Sign In or Sign Up'
    }
  }
}
